import { flattenPermissions } from "../../../../../app/state/storageObjectSlice/utils/flattenPermissions";
import {
  TObjectShareRequest,
  TObjectShareResponse,
  TPermissionPair,
} from "../../../../../services/api/instances/storageApi/types/service_types";

export const getUniqueSharedObjectsByUser = (
  accessObjects: TObjectShareResponse[],
  permissionsByObject: TObjectShareResponse[],
  objectId: string,
): TObjectShareRequest[] => {
  const existingForObject = accessObjects.filter(
    (o) => o.object_id === Number(objectId),
  );

  const existingUsernames = new Set(
    existingForObject.map((o) => o.username as string),
  );

  const flat = flattenPermissions(permissionsByObject);

  return flat.filter((p) => !existingUsernames.has(p.username as string));
};

export const syncPermissionPairs = (
  currentPairs: TPermissionPair[],
  usernames: string[],
): TPermissionPair[] => {
  return usernames
    .map((name) => name.replace("@education_tools", ""))
    .map((name) => {
      const existing = currentPairs.find((p) => p.username === name);
      return existing
        ? {
            ...existing,
            origin: existing.origin === "new" ? "new" : ("update" as const),
          }
        : {
            id: Date.now() + Math.floor(Math.random() * 1000),
            username: name,
            origin: "new" as const,
            isTemporary: true,
          };
    });
};
